import { SearchOutlined } from "@ant-design/icons";
import { Input, Select, Space } from "antd";
import React from 'react';
import { useDispatch } from 'react-redux';
import { SITE_TYPE } from "../../../../util/varibles/constants";
import { PlanSetting } from "../../../../util/varibles/userSetting";
import { loginActions } from "../../../LoginPage/reducer";
import AddExternalSite from "../_components/AddExternalSite";
import AvgWeight from "../_components/AvgWeight";
import CountSelected from "../_components/CountSelected";
import LiceSort from "../_components/LiceSort";
import stylesContainer from "../style.module.scss";
import Filter from "./Filter";

interface IProps {
    siteType: any
    searchValue: any
    weightFilter: [number | null, number | null],
    sites: any
    liceSort: null | string

    onSearch(value: { siteType?: SITE_TYPE, searchValue?: string, weightFilter?: [number | null, number | null] }): void
}

const HeaderUnits: React.FC<IProps> = (props) => {
    const dispatch = useDispatch();

    const handleChangeLice = (value: any) => {
        dispatch(loginActions.updateUserSetting([{ [PlanSetting.BIOLOGY_LICE_SORT]: value }]))
    }

    const { sites, weightFilter, liceSort, onSearch } = props;

    return <div className={stylesContainer['tab-header']}>
        <div className={stylesContainer['header-left']} data-operaion-type='units'>
            <LiceSort lice={liceSort} onChange={handleChangeLice} />
            <CountSelected />
            <Space.Compact className={[stylesContainer['search-group']].join(' ')}>
                <Select allowClear placeholder='Site type'
                    classNames={{ root: '!min-h-[30px]' }}
                    onChange={(value: any = '') => onSearch({ siteType: value })}
                    style={{ width: '100px' }}
                    options={[
                        { value: 'external', label: 'External', },
                        { value: 'internal', label: 'Internal', },
                    ]}
                />
                <Input
                    style={{ width: 'calc(100% - 100px)' }}
                    placeholder="Search site"
                    allowClear
                    onChange={({ target: { value } }: any) => onSearch({ searchValue: value })}
                    suffix={<SearchOutlined className='text-comment' />}
                />
            </Space.Compact>
            <AvgWeight weight={weightFilter} onChange={value => onSearch({ weightFilter: value })} />
        </div>
        <div className={stylesContainer['header-right']}>
            <Filter {...{ sites }} />
            <AddExternalSite />
        </div>
    </div>;
};

export default HeaderUnits;